import styled from 'styled-components';
import { NavigationControl } from 'react-map-gl';

export const StyledNavigationControl = styled(NavigationControl)`
  position: absolute;
  top: 8px;
  right: 8px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
`;

export const ActiveMarkerIcon = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid ${props => props.theme.colors.content.accent4};
  background: ${props => props.theme.colors.background.accent3};
`;

export const MarkerIcon = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #4f6981;
  background: rgba(160, 183, 205, 0.8);
`;

export const Wrapper = styled.div`
  .mapboxgl-control-container {
    display: none;
  }

  .mapboxgl-map {
    border-radius: ${props => props.theme.borderRadii.large};
  }

  .mapboxgl-popup-close-button {
    padding: 3px 8px;
  }
`;

export const MarkerChild = styled.div`
  &:hover {
    cursor: pointer;
  }
`;
